var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_forward_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_forward_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.085 8.5H3.5a.484.484 0 01-.356-.144A.484.484 0 013 8c0-.142.048-.26.144-.356A.484.484 0 013.5 7.5h7.585L7.638 4.054a.47.47 0 01-.146-.348.495.495 0 01.157-.355.522.522 0 01.351-.15.466.466 0 01.351.15l4.227 4.227a.552.552 0 01.17.422.552.552 0 01-.17.422l-4.227 4.227a.477.477 0 01-.343.141.499.499 0 01-.36-.141.49.49 0 01-.154-.357.49.49 0 01.155-.356L11.085 8.5z"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/arrow_forward.1f24ab20.svg";
export { SvgArrowForward as ReactComponent };